import { useParams } from "react-router-dom";

import { Sessions } from "~/providers/components/patientProfile/sessions/Sessions";

export const PatientSessions = () => {
  const { patientId } = useParams();

  if (!patientId) return null;

  return <Sessions patientId={patientId} />;
};
